import readinessCheckActions from '../actions/ReadinessCheckActions';

export const defaultState = { isReadinessCheckComplete: false, positions: {} };

export default function (state = defaultState, action) {
    switch (action.type) {
    case readinessCheckActions.types.READINESS_CHECK_COMPLETE:
        return { ...state, isReadinessCheckComplete: action.isReadinessCheckComplete };

    case readinessCheckActions.types.SET_READINESS_CHECK_VIDEO_POSITION:
        return {
            ...state,
            positions: {
                ...state.positions,
                [action.videoId]: action.position,
            },
        };

    default:
        return state;
    }
}
